import React, { useEffect, useRef } from "react";

// Sections only make sense over the complete list, so instead of Stream's
// "Load more" button we keep pulling pages in the background until Stream
// says there are none left (capped as a safety net).
export const MAX_AUTO_LOAD_PAGES = 10;

function AutoLoadPaginator({ children, hasNextPage, isLoading, loadNextPage }) {
  const pagesLoadedRef = useRef(0);

  useEffect(() => {
    if (!hasNextPage || isLoading) return;
    if (pagesLoadedRef.current >= MAX_AUTO_LOAD_PAGES) return;
    pagesLoadedRef.current += 1;
    loadNextPage();
  }, [hasNextPage, isLoading, loadNextPage]);

  const autoLoading =
    hasNextPage && pagesLoadedRef.current < MAX_AUTO_LOAD_PAGES;
  // Past the cap, keep a manual control so the rest stays reachable
  const showManualLoadMore = hasNextPage && !autoLoading;

  return (
    <>
      {children}
      {autoLoading && (
        <p className="px-4 py-3 text-center text-xs text-slate-400">
          Loading conversations…
        </p>
      )}
      {showManualLoadMore && (
        <div className="px-4 py-3 text-center">
          <button
            type="button"
            className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50"
            disabled={isLoading}
            onClick={loadNextPage}
          >
            {isLoading ? "Loading…" : "Load more conversations"}
          </button>
        </div>
      )}
    </>
  );
}

export default AutoLoadPaginator;
